import React, { Component } from 'react';
import ProjectCard from './projectcard'
import {PropTypes as MobxPropTypes} from 'mobx-react';
import {observer} from 'mobx-react'
@observer
class projectIntroduce extends Component {
  render() {
    const projects=this.context.store.projectsInfo
    return (
      <div className="App-main">
      <div className="side"></div>
      <div className="main">
      {projects.map((project,index)=><ProjectCard project={project} key={index.toString()}/>)}
      </div>
      <div className="side"></div>
      </div>
    );
  }
}
projectIntroduce.contextTypes={
  store:MobxPropTypes.observableObject.isRequired
}
export default projectIntroduce;


// WEBPACK FOOTER //
// ./src/projectIntroduce/index.js